module.exports = __webpack_public_path__ + "img/RatBNB2.cc188315.png";